import triggerTracking from '@blueprint/tracking';

export const trackClickSavedListingWidgetCard = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'saved property'
    });
};

export const trackClickSeeAllSavedListings = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'homepage',
        eventAction: 'clickthrough',
        eventLabel: 'see all saved properties'
    });
};
